import { EMachineConfigUIViewType } from '_clean-code/types/config';

export const NOTIFICATION_DISMISSION_STATUSES = {
  READ: 'read',
  DISMISS: 'dismiss'
};
export const defaultLang = 'es';
export const AUTH_USER_TOKEN_KEY = 'React.AmplifyAuth'; // TODO: this value is also in public/index.html as plain text please update it there
export const SELECTED_COMPANY_ID = 'Pulsar.SelectedCompanyId'; // TODO: this value is also in public/index.html as plain text please update it there
export const pageTitles = {
  '/dashboard': 'dashboard',
  '/machines': 'realtime',
  '/production': 'production',
  '/stops': 'stops',
  '/analytics': 'analytics(availability)',
  '/analytics/stop-annotation': 'analytics(stop annotation)',
  '/analytics/stops': 'analytics(stops)',
  'analytics/historical': 'analytics(historical)',
  'analytics/shift': 'analytics(shift)',
  'analytics/pareto': 'analytics(pareto for stops)',
  'analytics/pareto/filters': 'analytics(pareto for machines)',
  '/data/reports': 'data reports',
  '/stopsettings/downtime-causes': 'downtime causes',
  '/stopsettings/tree-losses': 'tree losses',
  '/stopsettings/assign-machine': 'stop settings(assign machines)',
  '/equipmentsettings/list': 'equipment list',
  '/equipmentsettings/assign-machine': 'equipment assignment',
  '/stopautomation': 'stop automation',
  '/production-settings/sku': 'skus',
  '/production-settings/work-order': 'work orders',
  '/production-settings/nominal-speed': 'nominal speeds',
  '/production-settings/machine-mapping': 'machine mappings',
  '/production-settings/operator': 'operators',
  '/alerts': 'alert settings',
  '/alerts/recipients': 'alert recipients',
  '/shift-not-considered': 'idle shifts',
  '/shift-settings': 'shift settings',
  '/tv-settings': 'tv settings',
  '/machine-settings': 'machine groups',
  '/users-settings': 'user settings',
  '/create-ticket': 'support ticket'
};
/**
 * The default locale is 'es'. Since it is not stored in the database,
 * english-speaking users displaying pulsar in remote devices may experience issues.
 * This is a list of company ids who will display pulsar in english by default
 */
export const US_LOCALE_COMPANY_IDS = [
  '10122' // BTD
];

/**
 * limit of rows to be downloaded in reports
 */
export const REPORTS_PAGE_SIZE = 1000;
export const STOPS_REPORT_PAGE_SIZE = 20_000;

/**
 * how often we poll for stops data in the stops page
 */
export const STOPS_REFRESH_INTERVAL = 1000 * 60;

export const REALTIME_SETTINGS = {
  /**
   * Whether the user can select multiple machines at once in the realtime settings
   */
  ALLOW_MULTI_MACHINE_CONFIG: true,
  /**
   * The maximum number of metrics that can be selected for a given view type
   */
  MAX_METRICS: {
    [EMachineConfigUIViewType.DesktopNonKpi]: 4,
    [EMachineConfigUIViewType.TvKpi]: 4,
    [EMachineConfigUIViewType.TvSingleMachine]: 4,
    [EMachineConfigUIViewType.TvTowerView2x2]: 4,
    [EMachineConfigUIViewType.TvTowerView3x3]: 2,
    [EMachineConfigUIViewType.TvTowerView6x3]: 0
  }
};
